export const keyCodes = {
    enter: 13,
    escape: 27
};

export type FilterTypes = 'all' | 'active' | 'complited';



// WEBPACK FOOTER //
// ./src/common.ts